module.exports = __webpack_public_path__ + "static/img/hnweR404A.f9eef1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productList/internationalBrand/hnweR404A.jpg
// module id = oki7
// module chunks = 1